import { z } from 'zod';
import { legalPersonSchema } from './ILegalPerson';
import { naturalPersonSchema } from './INaturalPerson';

const EditableLegalClientAddressSchema = z.object({
  idPostcode: z.number(),
  Street: z.string().nullable().optional(),
  Number: z.string().nullable().optional(),
  StreetAdditional: z.string().nullable().optional(),
});

export const EditableLegalClientSchema = naturalPersonSchema
  .and(legalPersonSchema)
  .and(
    z.object({
      idLegalClient: z.number().int(),
      idLegalClientType: z.number().int(),

      AddressArray: z.array(EditableLegalClientAddressSchema).min(1, {
        message: 'Mindestens eine Adresse ist erforderlich',
      }),
      Email: z.string().email().nullable(),

      data: z.object({
        addToLegalTransaction: z.boolean().optional(),
      }),
    })
  )
  .superRefine((data, ctx) => {
    if (
      data.data.addToLegalTransaction &&
      (data.Email === null || data.Email === '')
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message:
          'E-Mail ist erforderlich, wenn für den Mandanten ein Account angelegt werden soll.',
        path: ['Email'],
      });
    }

    const addressAdditionalRequired = [
      { field: 'Street', displayName: 'Straße' },
      { field: 'Number', displayName: 'Hausnummer' },
    ];
    data.AddressArray.forEach((address, index) => {
      addressAdditionalRequired.forEach(({ field, displayName }) => {
        if (
          !address[field as keyof typeof address] ||
          (typeof address[field as keyof typeof address] === 'string' &&
            (address[field as keyof typeof address] as string).trim() === '')
        ) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `${displayName} ist erforderlich.`,
            path: ['AddressArray', index, field],
          });
        }
      });
    });
  });

export type IEditableLegalClient = z.infer<typeof EditableLegalClientSchema>;
